import { Link } from "react-router-dom";
import { Hero } from "@/components/nobo/Hero";
import { WaitlistForm } from "@/components/nobo/WaitlistForm";
import { Rules } from "@/components/nobo/Rules";
import { Steps } from "@/components/nobo/Steps";

const IG_URL = "https://instagram.com/noborunclub";
const BELT = "no one left behind \u2022 run slow \u2022 coffee after \u2022 bring a friend \u2022 walk breaks are valid \u2022 ";

export default function Landing() {
  return (
    <div className="nobo">
      <div className="wrap">
        <Hero />
        <div className="grid" id="waitlist">
          <WaitlistForm igUrl={IG_URL} />
          <Rules />
        </div>
        <Steps />
        <div className="belt" aria-hidden="true">
          <div>{BELT.repeat(8)}</div>
        </div>
        <footer>
          <span>
            NOBO Run Club · <Link to="/organiser" className="org-link" data-testid="footer-organiser-link">organiser</Link>
          </span>
          <a className="ig" href={IG_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link">
            @noborunclub
          </a>
        </footer>
      </div>
    </div>
  );
}
